module.exports = __webpack_public_path__ + "img/FirstResult.b7713ad5.jpg";